// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__zlP0e","argentinaUnida":"Header_argentinaUnida__w5UKt"};